import { GlLoadingIcon, GlIcon } from '@gitlab/ui';
import { capitalizeFirstCharacter } from '~/lib/utils/text_utility';
import { EXTENSION_ICON_CLASS, EXTENSION_ICON_NAMES } from '../../constants';
export default {
    name: 'StatusIcon',
    components: {
        GlLoadingIcon,
        GlIcon
    },
    props: {
        level: {
            type: Number,
            required: false,
            default: 1
        },
        name: {
            type: String,
            required: false,
            default: ''
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        iconName: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        iconAriaLabel () {
            return `${capitalizeFirstCharacter(this.iconName)} ${this.name}`;
        },
        backgroundClass () {
            return this.$options.EXTENSION_ICON_CLASS[this.iconName]?.backgroundClass;
        },
        iconClass () {
            return this.$options.EXTENSION_ICON_CLASS[this.iconName]?.iconClass;
        }
    },
    EXTENSION_ICON_NAMES,
    EXTENSION_ICON_CLASS
};
